import {
  getSchema as getSchema1,
  getValidate as getValidate1,
  uiSchema as uiSchema1,
} from "./schema.rentmatchScoreBroker.1";
import { IExtraData } from "./schema.rentmatchScoreBroker.types";
import { getInitialValues } from "./schema.rentmatchScoreBroker.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues),
      uiSchema: uiSchema1(),
      validate: getValidate1(),
    },
  ];
};
